import { createFileRoute } from "@tanstack/react-router";
import { CompanyLinkPage } from "../screens/company-links/index.ts";

/** `/company/restore#<token>`: the link in the mail that brings a deleted company back. */
export const Route = createFileRoute("/company/restore")({
  component: () => <CompanyLinkPage kind="restore" />,
});
